import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDatapicker',
  setup(__props) {

const defaultCalander = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/defaultCalander.vue"))
const bootstrapCalendar = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/bootstrapCalendar.vue"))
const datePicker = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/datePicker.vue"))
const timePicker = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/timePicker.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Widgets",
      title: "Date Picker"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defaultCalander)),
        _createVNode(_unref(bootstrapCalendar)),
        _createVNode(_unref(datePicker)),
        _createVNode(_unref(timePicker))
      ])
    ])
  ], 64))
}
}

})